import { render, staticRenderFns } from "./SettingsIntegrationsListTitle.vue?vue&type=template&id=2dfb77f4&"
import script from "./SettingsIntegrationsListTitle.vue?vue&type=script&lang=js&"
export * from "./SettingsIntegrationsListTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports